// Copyright 2025. WebPros International GmbH. All rights reserved.

export const LOADER = 'loader';